import "core-js/modules/es.function.name.js";
import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7f6e1aa4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "listDetail"
};
var _hoisted_2 = {
  key: 0,
  class: "listDetail-box"
};
var _hoisted_3 = {
  class: "list-title"
};
var _hoisted_4 = {
  class: "list"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "iconfont icon-icon_horn songIndex active"
};
var _hoisted_7 = {
  class: "songIndex"
};
var _hoisted_8 = {
  key: 0,
  class: "song-name linelittle"
};
var _hoisted_9 = ["innerHTML"];
var _hoisted_10 = {
  class: "songer linelittle"
};
var _hoisted_11 = {
  key: 0
};
var _hoisted_12 = ["innerHTML"];

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "slash"
  }, "/", -1
  /* HOISTED */
  );
});

var _hoisted_14 = {
  key: 2,
  class: "album linelittle"
};
var _hoisted_15 = ["innerHTML"];
var _hoisted_16 = {
  class: "duration"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Loading = _resolveComponent("Loading");

  var _directive_minTenIndex = _resolveDirective("minTenIndex");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.musicList.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createCommentVNode(" 标题区域 "), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTitle, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['title', item.class]),
      key: item
    }, _toDisplayString(item.title), 3
    /* TEXT, CLASS */
    );
  }), 128
  /* KEYED_FRAGMENT */
  ))]), _createCommentVNode(" 列表区域 "), _createElementVNode("div", _hoisted_4, [_createCommentVNode(" 歌曲item项 "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.musicList, function (song, songIndex) {
    var _song$al, _song$album, _song$album2;

    return _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "list-item",
      key: song.id,
      onClick: function onClick($event) {
        return _ctx.songItemClick(song.id);
      }
    }, [_createCommentVNode(" 播放图标 "), _withDirectives(_createElementVNode("i", _hoisted_6, null, 512
    /* NEED_PATCH */
    ), [[_vShow, _ctx.currentId == song.id]]), _createCommentVNode(" 索引 "), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [_createTextVNode(_toDisplayString(songIndex + 1), 1
    /* TEXT */
    )])), [[_vShow, _ctx.currentId !== song.id], [_directive_minTenIndex]]), _createCommentVNode(" lightKeyword "), _createCommentVNode(" 歌名 "), !_ctx.inputValue ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(song.name), 1
    /* TEXT */
    )) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createCommentVNode(" 歌名高亮 "), _createElementVNode("div", {
      class: "song-name linelittle",
      innerHTML: _ctx.lightKeyword(song.name, _ctx.inputValue)
    }, null, 8
    /* PROPS */
    , _hoisted_9)], 2112
    /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
    )), _createCommentVNode(" 歌手 "), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(song.ar || song.artists, function (songer) {
      return _openBlock(), _createElementBlock("span", {
        class: "songer-item",
        key: songer.id
      }, [!_ctx.inputValue ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(songer.name), 1
      /* TEXT */
      )) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createCommentVNode(" 歌手高亮 "), _createElementVNode("span", {
        innerHTML: _ctx.lightKeyword(songer.name, _ctx.inputValue)
      }, null, 8
      /* PROPS */
      , _hoisted_12)], 2112
      /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
      )), _hoisted_13]);
    }), 128
    /* KEYED_FRAGMENT */
    ))]), _createCommentVNode(" 专辑 "), !_ctx.inputValue ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(((_song$al = song.al) === null || _song$al === void 0 ? void 0 : _song$al.name) || ((_song$album = song.album) === null || _song$album === void 0 ? void 0 : _song$album.name)), 1
    /* TEXT */
    )) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 3
    }, [_createCommentVNode(" 专辑高亮 "), _createElementVNode("div", {
      class: "album linelittle",
      innerHTML: _ctx.lightKeyword((_song$album2 = song.album) === null || _song$album2 === void 0 ? void 0 : _song$album2.name, _ctx.inputValue)
    }, null, 8
    /* PROPS */
    , _hoisted_15)], 2112
    /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
    )), _createCommentVNode(" 时长 "), _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$filters.formatTime(song.dt || song.duration, "mm:ss")), 1
    /* TEXT */
    )], 8
    /* PROPS */
    , _hoisted_5)), [[_vShow, song]]);
  }), 128
  /* KEYED_FRAGMENT */
  ))])])) : (_openBlock(), _createBlock(_component_Loading, {
    key: 1
  }))]);
}